<template>
	<v-list-item v-if="canExport">
		<router-link to="/conversion-reports" class="mr-auto user__link">
			Conversion reports
		</router-link>
	</v-list-item>
</template>

<script>
import api from "./api.js";
import { rolesTypes } from "../../../shared/configs/roles.js";

export default {
	name: "ConversionReportsMenuLink",
	props: { user: { type: Object, default: null } },
	data: () => ({ canExport: false }),
	watch: {
		user: {
			immediate: true,
			async handler(user) {
				this.canExport = user?.role === rolesTypes.ADMIN;
				if (!user || this.canExport) return;
				try {
					const access = await api.getAccess();
					if (this.user === user) this.canExport = access.canExport;
				} catch {
					// A failed optional report check must not affect the account menu.
					if (this.user === user) this.canExport = false;
				}
			},
		},
	},
};
</script>
